import { UIHeading2 } from '@cian/ui-kit';
import { plural } from '@cian/utils';
import { useSelector } from 'react-redux';

import { QUESTIONS_COUNT_PLURAL, REVIEWS_COUNT_PLURAL } from '../../constants/reviews';
import { getObjectInfo } from '../../selectors/objectInfo';
import { getReviewsConfig } from '../../utils/getReviewsConfig/getReviewsConfig';

export const TabsHeaderContainer = () => {
  const { reviewsCount, questionsCount } = useSelector(getObjectInfo);

  const reviewsConfig = getReviewsConfig();

  let title = `${reviewsCount} ${plural(reviewsCount, REVIEWS_COUNT_PLURAL)}`;

  if (reviewsConfig.SHOW_REVIEWS_TABS) {
    title += ` и ${questionsCount}
      ${plural(questionsCount, QUESTIONS_COUNT_PLURAL)}`;
  }

  return <UIHeading2>{title}</UIHeading2>;
};
